import Tracker from '@openreplay/tracker'

export default {
    install: (app, options) => {
        const tracker = new Tracker({
            projectKey: process.env.VUE_APP_OPEN_REPLAY,
            ingestPoint: "https://repl.kegel-plan.com/ingest",
            defaultInputMode: 0,
            obscureTextNumbers: false,
            obscureTextEmails: false,
            obscureInputEmails: false,
            network: {
                capturePayload: true // Capture HTTP payload
              },
            capturePerformance: false
  
        });

        app.config.globalProperties.$tracker = tracker
        tracker.start();
        return tracker
    }
}
